module.exports = __webpack_public_path__ + "static/media/02_hero_desktop.97ad2a95.jpg";